import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=16955ab1&"
import script from "./TextMessage.vue?vue&type=script&lang=js&"
export * from "./TextMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports